/** Hands the browser a text file to save. CSV files start with a byte-order mark so spreadsheets read them as UTF-8. */
export function downloadText(
  fileName: string,
  text: string,
  type = 'text/csv;charset=utf-8',
): void {
  const body = type.startsWith('text/csv') ? `\uFEFF${text}` : text;
  const url = URL.createObjectURL(new Blob([body], { type }));
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Safari on a phone reads the file after the click returns: the address is kept for a minute
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
